<template>
    <mu-raised-button label="Raised 按钮" />
</template>
<script>
export default {
    name: 'FlatButton'
}
</script>



// WEBPACK FOOTER //
// RaisedButton.vue?0f0193d8